export default __webpack_public_path__ + "static/media/Gloves of the Wells of Night.76697434.jpg";